import React from "react"

import {
  CssBaseline,
  ThemeProvider,
  useTheme,
  Typography,
} from "@material-ui/core"

import logo from "../images/article-logo.png"
import theme from "../utility/theme"
import SEO from "../components/seo"
import Layout from "../components/layouts/layout"
import ArticleSection from "../components/layouts/article-section"
import GeneralSection from "../components/layouts/general-section"
import Quote from "../components/quote"
import Strong from "../components/strong"

const AboutPage = () => {
  const theme = useTheme()

  return (
    <Layout data={theme.data.pages.about}>
      <SEO title="About" />
      <ArticleSection
        mb="100px"
        img={logo}
        alt="Efficient Accounting Services LTD."
        headingVariant="h2"
        heading="EFFICIENT ACCOUNTING LTD."
        textAlign="justify"
        primaryLabel="CONTACT US"
        primaryHref={theme.data.emailHref}
      >
        <Typography gutterBottom>
          Efficient Accounting was created for the sole purpose of helping
          friends out with administrative and support services. Gally Shapiama
          Flores really wanted to grow her own business and was looking for
          someone to partner with, who she can trust fully with her business.
          While working a few years ago, Gally soon she met Ying Mei Yeh. The
          two found that they were both equally trustworthy and the rest was
          history!
        </Typography>
        <Typography gutterBottom>
          We are now a fast growing team of accounting professionals who provide
          services to small, medium size companies. Our service is deliver in a
          friendly, accurate, efficient and in a timely manner giving our
          clients the peace of mind they need to focus in running their
          businesses.
        </Typography>
        <Typography gutterBottom>
          Some of our clients are coming from different backgrounds:
          construction, electrical, restaurants, and cleaning. They came to us
          because some wanted to start a business and some wanted guidance on
          how to do accounting. We provided them with advise and help them with
          full cycle bookkeeping, payroll process, corporate taxes, personal
          taxes and secretarial services. We also represented them with Canada
          Revenue Agency.
        </Typography>
        <Typography gutterBottom>
          Languages written and spoken: <Strong>Spanish</Strong>,{" "}
          <Strong>Mandarin</Strong>, and <Strong>English</Strong>.
        </Typography>
        <Typography gutterBottom>
          Contact us at: <Strong>+1-778-889-3619</Strong> or{" "}
          <Strong>office@efficientaccounting.ca</Strong>
        </Typography>
      </ArticleSection>
      <GeneralSection mb={12.5}>
        <Quote
          classes={{ bgImage: theme.data.pages.about.pageName }}
          imgName="quote-bg2.jpg"
          quote='"We are compassionate to the people who need help. We serve with integrity and strong moral conduct that will lead our team to the right kind of success. We believe that honesty always is the best way to overcome hurdles."'
          author="~ Efficient Accounting Team"
          // To override the defaults of gatsby-background-image
          style={{ backgroundPosition: "" }}
        />
      </GeneralSection>
      <ArticleSection
        mb="100px"
        headingVariant="h2"
        heading="GALLY SHAPIAMA FLORES"
        textAlign="justify"
      >
        <Typography gutterBottom>
          Gally is a mother of three kids. She came to Canada to work and study
          at the same time. She can speak both <Strong>Spanish</Strong> and{" "}
          <Strong>English</Strong> and is a Permanent Resident of Canada.
        </Typography>
        <Typography gutterBottom>
          She took an accounting course and to her surprise she really liked it!
          When it was time to take the Canadian accounting program in Douglas
          College, it was an extra challenge because of the language barrier. In
          the end, she managed to overcome and persevere because she knew that
          she wanted to help people through accounting. She is inspired to work
          as an accountant is to solve her clients accounting problems.
        </Typography>
      </ArticleSection>
      <ArticleSection
        mb="100px"
        headingVariant="h2"
        heading="YING MEI YEH"
        textAlign="justify"
        primaryLabel="CONTACT US"
        primaryHref={theme.data.emailHref}
      >
        <Typography gutterBottom>
          Ying is a graduate of Douglas College with more than twenty years of
          experience in public practice. She can speak both{" "}
          <Strong>Mandarin</Strong> and <Strong>English</Strong> fluently.
        </Typography>
        <Typography gutterBottom>
          She likes to analyze the clients business situation, and give them
          advise. She helps not only her clients but everyone who needs her
          because she loves to relate to other’s situations.
        </Typography>
        <Typography gutterBottom>
          Gally and Ying both believe that <Strong>compassion</Strong> and
          having a <Strong>sympathetic heart</Strong> towards the sufferings or
          misfortunes of others is what drives them to help people. They believe
          that having a <Strong>strong moral compass</Strong> that creates the
          company core values is the best way to conduct yourself towards
          others. Above all, they both believe that <Strong>honesty</Strong>{" "}
          should not only be telling the truth but also living the truth.
        </Typography>
      </ArticleSection>
    </Layout>
  )
}

const StyledAboutPage = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <AboutPage />
  </ThemeProvider>
)

export default StyledAboutPage
